import Kenshui30Page, { getServerSideProps } from './index';

export default Kenshui30Page;

export { getServerSideProps };
